module.exports = {
      id: "lulu-money-usage",
      viewBox: "0 0 398 134",
      url: __webpack_public_path__ + "svg-sprite-c71831da97eff2ec188167649c252867.svg#lulu-money",
      toString: function () {
        return this.url;
      }
    }